import { default as CheckServiceShieldIcon } from '~/assets/images/check-service-shield-icon.svg';

const CompanyPartnershipLogo: React.FC = () => {
  return (
    <div className="inline-flex min-w-40 items-center gap-2">
      <img
        src={CheckServiceShieldIcon as string}
        alt="Partner van Advieskeuze"
        className="w-10 object-cover pt-2 md:w-12"
      />
      <h2 className="flex flex-col gap-1">
        <span className="inline-block font-avantgarde text-sm font-light leading-none text-blue-800">
          Partner van
        </span>
        <span className="inline-block font-avantgarde text-lg font-bold leading-none text-blue-700">
          Advieskeuze
        </span>
      </h2>
    </div>
  );
};

export default CompanyPartnershipLogo;
